import MiddlewareModule from "modules/Core/core-modules/MiddlewareModule";
import { MEMBERSHIP } from "../consts";

export default new MiddlewareModule({
    name: MEMBERSHIP,
    operations: {
        create: `
            mutation initMembership($tier: String) {
                initMembership(tier: $tier) {
                    amount
                    currency
                    clientSecret
                }
            }
        `,
        fetchFeed: `
            query subscriptions($feedParams: FeedParams) {
                feed: subscriptions(feedParams: $feedParams) {
                    entities {
                        id
                        user {
                            email
                            id
                        }
                        stamps {
                            activatedDate
                        }
                        subscriptionId
                        tier
                    }
                }
            }
`,
        cancel: `
            mutation cancelMembership{
                cancelMembership
            }
        `,
    },
});